<template>
  <div class="tabs" :class="{'contract': !advancedTabs, 'pages-tabs': ['bots', 'posts', 'planner', 'moderation', 'reporting'].includes($route.name)} " v-click-outside="contractTabs">
    <div class="logo-wrapper">
      <img class="logo" src="../../assets/img/logo_mw_social_white_small.png" alt="Mashup logo">
    </div>
     
    <div id="parentx">
      <vs-sidebar
        :static-position="this.static || true ? true : false"
        class="sidebarx"
        spacer
        v-model="active"
      >

        <vs-sidebar-item
          index="0"
          icon="home"
          @click="change(0, 'overview')"
          :class="{ 'active' : !$route.name}"
        >
          <a>None</a>
        </vs-sidebar-item>  
    
        
        <vs-sidebar-item
          index="1"
          @click="change(1, 'overview')"
          :class="{ 'active' : $route.name === 'overview'}"
          data-qa="nav-overview"
        >
          <Tooltip :position="'right'" :text="$t('dash.tab.overview')">
            <img src="../../assets/img/tabs/ico-overview.svg" alt="overview">
            <a>{{$t('dash.tab.overview')}}</a>
          </Tooltip>
        </vs-sidebar-item>
        <vs-sidebar-item
          v-if="['Admin', 'Editor', 'Viewer'].includes(getUserRole)"
          index="2"
          @click="change(1, 'pages')"
          :class="{ 'active' : $route.name === 'pages'}"
          data-qa="nav-pages"
        >
          <Tooltip :position="'right'" :text="$t('dash.tab.pages')">
            <img src="../../assets/img/tabs/ico-pages.svg" alt="pages">
            <a>{{$t('dash.tab.pages')}}</a>
          </Tooltip>
        </vs-sidebar-item>



        <vs-sidebar-item
          v-if="['Admin', 'Editor'].includes(getUserRole) && getUserPlan"
          index="3"
          @click="change(1, 'bots')"
          :class="{ 'active' : $route.name === 'bots'}"
          data-qa="nav-bots"
        >
          <Tooltip :position="'right'" :text="$t('dash.tab.bots')">
            <img src="../../assets/img/tabs/ico-bots.svg" alt="bots">
            <a>{{$t('dash.tab.bots')}}</a>
          </Tooltip>
        </vs-sidebar-item>

        <template v-if="version === 'old' && getUserPlan">
          <vs-sidebar-item
            index="4"
            @click="change(1, 'posts')"
            :class="{ 'active' : $route.name === 'posts'}"
            data-qa="nav-posts"
          >
            <Tooltip :position="'right'" :text="$t('dash.tab.posts')">
              <img src="../../assets/img/tabs/ico-posts.svg" alt="posts"/>
              <a to="./posts">{{$t('dash.tab.posts')}}</a>
            </Tooltip>
          </vs-sidebar-item>

        </template>

        <vs-sidebar-item
          v-if="activePlanner && getUserPlan"
          index="5"
          @click="change(1, 'planner')"
          :class="{ 'active' : $route.name === 'planner' || $route.name === 'posts2'}"
          data-qa="nav-planner"
        >
          <Tooltip :position="'right'" :text="$t('dash.tab.scheduler')">
            <img src="../../assets/img/tabs/ico-planner.svg" alt="scheduler"/>
            <a to="./posts">{{$t('dash.tab.scheduler')}}</a>
          </Tooltip>
        </vs-sidebar-item>
        <vs-sidebar-item
          v-if="activeModeration && ['Admin', 'Editor', 'Writter'].includes(getUserRole) && getUserPlan"
          index="6"
          @click="change(1, 'moderation')"
          :class="{ 'active' : $route.name === 'moderation'}"
          data-qa="nav-moderation"
        >
          <Tooltip :position="'right'" :text="$t('dash.tab.moderation')">
            <img src="../../assets/img/tabs/ico-moderation.svg" alt="moderation">
            <a to="./posts">{{$t('dash.tab.moderation')}}</a>
            <span v-if="countInboxEvents" class="count">{{ countInboxEvents }}</span>
          </Tooltip>
        </vs-sidebar-item>
    
        <vs-sidebar-item
          index="8"
          @click="change(1, 'reporting')"
          :class="{ 'active' : $route.name == 'reporting'}"
          v-if="activeReporting && ['Admin', 'Editor', 'Writter'].includes(getUserRole) && getUserPlan"
          data-qa="nav-reporting"
        >
          <Tooltip :position="'right'" :text="$t('dash.tab.reporting')">
            <img src="../../assets/img/tabs/ico-reporting.svg" alt="reporting">
            <a to="./reporting">{{$t('dash.tab.reporting')}}</a>
          </Tooltip>
        </vs-sidebar-item>
        <vs-sidebar-item
          v-if="['Admin', 'Editor'].includes(getUserRole) && getUserPlan"
          index="7"
          @click="change(1, 'sources')"
          :class="{ 'active' : $route.name == 'sources'}"
          data-qa="nav-sources"
        >
          <Tooltip :position="'right'" :text="$t('dash.tab.sources')">
            <img class="pink" src="../../assets/img/tabs/ico-sources.svg" alt="sources">
            <a to="./sources">{{$t('dash.tab.sources')}}</a>
          </Tooltip>
        </vs-sidebar-item>


      </vs-sidebar>

      <div class="settings-wrapper"
          :class="{ 'active' : $route.name == 'settings'}"
          @click="change(0, 'settings')"
          v-if="['Admin', 'Editor', 'Writter'].includes(getUserRole)">
          <Tooltip :position="'right'" :text="$t('dash.header.nav.settings')">
            <img class="pink" src="../../assets/img/tabs/ico-settings.svg" alt="settings">
            <a to="./settings">{{$t('dash.header.nav.settings')}} <span>{{ applicationVersion }}</span></a>
          </Tooltip>
      </div>
      <div class="user-wrapper">
        <vs-dropdown vs-custom-content vs-trigger-click color="#B20564">
          <a class="a-icon" href.prevent v-if="this.userProp">
            <vs-avatar color="#f9f9f9" size="22px" v-if="!this.userProp.avatar || !this.userProp.avatar.length" :src="require('../../assets/img/ico-man.svg')"/>
            <vs-avatar v-if="this.userProp.avatar && !!this.userProp.avatar.length" :src="this.userProp.avatar"/>
            <p class="user-name" v-if="this.userProp.firstname && this.userProp.lastname">{{this.userProp.firstname}} {{this.userProp.lastname}}</p>
            <p class="user-name" v-if="!this.userProp.firstname || !this.userProp.lastname">{{$t('dash.header.myaccount')}}</p>
            <i class="material-icons">keyboard_arrow_down</i>
          </a>
          <vs-dropdown-menu class="loginx">
            <vs-dropdown-item @click="change(0, 'settings')" v-if="['Admin', 'Editor', 'Writter'].includes(getUserRole)">
              <div class="dropdown-item">
                <a>
                  <img
                    src="../../assets/img/header/nav/ico-gear.svg"
                    alt="settings"
                  >
                  <p>{{$t('dash.header.nav.settings')}} <span>{{ applicationVersion }}</span></p>
                </a>
              </div>
            </vs-dropdown-item>
            <vs-dropdown-item @click="change(0, 'invoice')">
              <div class="dropdown-item">
                <a>
                  <img
                    src="../../assets/img/header/nav/ico-invoice.svg"
                    alt="invoice"
                  >
                  <p>{{$t('dash.header.nav.invoice')}}</p>
                </a>
              </div>
            </vs-dropdown-item>
            <vs-dropdown-item>
              <div class="dropdown-item">
                <a href="mailto:contact@mashup-web.com">
                  <img
                    src="../../assets/img/header/nav/ico-support.svg"
                    alt="support"
                  >
                  <p>{{$t('dash.header.nav.support')}}</p>
                </a>
              </div>
            </vs-dropdown-item>
             <vs-dropdown-item v-if="pwaInstalled">
              <div class="dropdown-item">
                <a @click="installPwa">
                  <img
                    src="../../assets/img/header/nav/pwa-install.svg"
                    alt="application"
                  >
                  <p>{{$t('dash.header.nav.pwa')}}</p>
                </a>
              </div>
            </vs-dropdown-item>
            <vs-dropdown-item @click="change(0, 'logout')">
              <div class="dropdown-item">
                <a>
                  <img src="../../assets/img/header/nav/log-out.svg" alt="logout">
                  <p>{{$t('dash.header.nav.logout')}}</p>
                </a>
              </div>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <div class="language-wrapper">
        <vs-dropdown vs-custom-content vs-trigger-click color="#B20564">
          <a class="a-icon" href.prevent>
            <p class="locale">{{ this.$i18n.locale }}</p>
            <i class="material-icons">keyboard_arrow_down</i>
          </a>
          <vs-dropdown-menu class="select-lang">
            <vs-dropdown-item v-for="lang in locales" :key="lang" :class="lang" @click="changeLocale(lang)">
              <p>{{ lang }}</p>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

    </div>

    <vs-prompt
      color="#6a1f4c"
      @close="closeDisclaimerPost"
      @cancel="closeDisclaimerPost"
      :cancel-text="$t('dash.posts.disclaimer-post.change-tab.prompt.btn-cancel')"
      @accept="change(savedUpdate.index, savedUpdate.section)"
      :accept-text="$t('dash.posts.disclaimer-post.change-tab.prompt.btn-continue')"
      :title="$t('dash.posts.disclaimer-post.change-tab.prompt.title')"
      :active.sync="showDisclaimerPost"
      class="prompt-remove-posts">
        <div class="con-exemple-prompt">
          {{$t('dash.posts.disclaimer-post.change-tab.prompt.content')}}          
        </div>
    </vs-prompt>

  </div>
</template>

<script>

import User from './../mixins/User'
import Moderation from './../mixins/Moderation'
import ClickOutside from 'vue-click-outside'
import { version } from "./../../../package.json"
import Tooltip from './tooltip/tooltipInit.vue';

export default {
  name: 'component-tabs',

  mixins: [User, Moderation],

  components: {
    Tooltip,
  },

  directives: {
    ClickOutside
  },

  data() {
    return {
      active: true, //false,
      static: false,
      window: {
        width: 0
      },
      advancedTabs: false,
      locales: ['en', 'fr', 'de', 'es', 'pt', 'it'],
      pwaInstalled: null,
      showDisclaimerPost: false,
      savedUpdate: null,
      applicationVersion: version,
      countInboxEvents: 0,
      version: localStorage.getItem('version_') === null ? 'beta' : localStorage.getItem('version_'),
    }
  },
  props: {
    scrolled: {
      type: Boolean,
      required: true
    },
    section: String,
    userProp: {
      type: Object
    },
    checkDisclaimerPost: Boolean
  },

  created() {
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      this.pwaInstalled = e;
    })
    window.addEventListener('appinstalled', () => {
      this.pwaInstalled = null;
    })

    if(this.userProp) {
      this.countWaitingEvents(this.userProp.account).then((res) => {
        console.log(res)
        if(res && res.body && res.body.pages) {
          let counts = res.body.pages.filter(p => ((!this.userProp.pages_access || !this.userProp.pages_access.length) && this.userProp.admin) || (this.userProp.pages_access && this.userProp.pages_access.includes(p.id))).map(p => p.count || 0)
          this.countInboxEvents = counts.reduce((s, a) => s + a, 0);
        }
      })
    }
  },

  computed: {
    getUserRole() {
      if(!this.userProp) return null
      if(this.userProp.admin)
        return 'Admin'
      else
        return this.userProp.role && this.userProp.role.length
                    ? this.userProp.role[0]
                    : 'Editor'
      
    },

    activePlanner() {
      const accounts = [
        'aed13e10-be3d-4d3b-840f-a1f4765383ac', //newcom-regie
      ]
      const user = this.user ? this.user
                              : (localStorage.user && localStorage.user != 'undefined' ? JSON.parse(localStorage.user) : null)
      const force = localStorage.forcePlanner ? JSON.parse(localStorage.forcePlanner) : false
      return user && (accounts.includes(user.account) || this.checkLock('planner') || user.email.includes("@mashup-web.com") || force == true)
    },
    
    activeModeration(){
      const accounts = [
        'e480002b-1c62-41e6-968f-c09d365b0741', //reworld
        'aed13e10-be3d-4d3b-840f-a1f4765383ac', //newcom-regie
        'abc0a72e-3274-4d30-b0e9-6af7c3e323ba', //deblasi.stefane
      ]
      const user = this.user ? this.user
                              : (localStorage.user && localStorage.user != 'undefined' ? JSON.parse(localStorage.user) : null)
      const force = localStorage.forceModeration ? JSON.parse(localStorage.forceModeration) : false
      return user && (accounts.includes(user.account) || this.checkLock('moderation') || user.email.includes("@mashup-web.com") || this.activeInstagramStories() || force == true)
    },

    activeReporting(){
      const user = this.user ? this.user
                              : (localStorage.user && localStorage.user != 'undefined' ? JSON.parse(localStorage.user) : null)
      const force = localStorage.forceReporting ? JSON.parse(localStorage.forceReporting) : false
      return user && (this.checkLock('reporting') || user.email.includes("@mashup-web.com") || this.activeInstagramStories() || force == true)
    }
  },

  methods: {

    activeInstagramStories() {
        const accounts = [
            '63fc164e-60da-41a7-9619-0c5fe6561239', //next-plz
            'b0291610-4743-4420-91ee-ea5699647106', //motoblouz
            'a8276ad6-bfe0-4866-a5b0-9fbf14003b27', //objectifgard
            '1863bfe3-f179-49a5-8baa-b1edb7e3282d', //doorinsider
            '9b76ba80-38e5-4b8f-9705-6aaf5259b946', //iadfrance
            '36522076-7ed1-4964-8323-1fd8d773012f', //agenceqg
            '7f0e5b02-a627-432f-89eb-83317b03e478', //santeclair.fr
            '90e789fa-7377-434c-b719-132aa8bcd1d2',  //keepeo.fr
            'cbdec673-84ab-401b-8882-0a72fa29b510',  //archi-tech.digital
            '6a1edfc6-eed2-4945-a48b-5be437a5e955',  //uncertainnicolas
            '411af69b-6839-421f-87d3-2cac55a5cbb3', //auto123
            '485a2ce9-b925-4962-a7eb-3abefebfd134', //komeocreation
        ]

        const user = JSON.parse(localStorage.user)
        return accounts.includes(user.account) || this.checkLock('instagram_credentials') || user.email.includes("@mashup-web.com")
    },

    closeDisclaimerPost() {
      this.showDisclaimerPost = false
      this.savedUpdate = null
    },

    async installPwa() {
      this.pwaInstalled.prompt()
      this.pwaInstalled.userChoice.then((choice) => {
        console.log(choice.outcome, choice)
        if (choice.outcome === 'accepted') {
          // Do something additional if the user chose to install
        } else {
          // Do something additional if the user declined
        }
      })
    },

    changeLocale(lang) {
      localStorage.setItem('language', lang)
      this.$i18n.locale = lang
      this.saveLocale(this.userProp.id, this.$i18n.locale)
    },

    toggleExpandTabs() {
      this.advancedTabs = !this.advancedTabs
    },

    contractTabs(){
      this.advancedTabs = false
    },

    /**
     * Change section on tab click
     */
    change(index, section) {
      //update session_start
      localStorage.setItem('session_start', Date.now())
      
      localStorage.removeItem('synchronizedPosts')
      localStorage.removeItem('postingInProgress')

      console.log('this.checkDisclaimerPost 2', this.checkDisclaimerPost)
      if(this.checkDisclaimerPost) {
        this.$emit('disclaimer-post', false)
        this.savedUpdate = {index, section}
        this.showDisclaimerPost = true
        return
      }

      this.showDisclaimerPost = false
      this.$emit('disclaimerPost', false)

      this.$emit('initTabsMinimize')

      if (['bots', 'posts', 'planner', 'moderation', 'reporting', 'sources'].includes(section) && (!localStorage.pages || !localStorage.pages.length))
        return this.$emit('tab-clicked', 1, 'pages')
      
      if(section == localStorage.section) {
          this.$router.push('/')
          this.$router.replace({ 
            name: section,
          })
      } else {
        localStorage.setItem('section', section)
        location.href = `/#/dash/${section}`
      }
    },
    /**
     * Handle window resize for responsive behavior
     */
    resize() {
      this.window.width = window.innerWidth
      this.tabstate()
    },
    /**
     * Display tabs on desktop
     */
    tabstate() {
      if (this.window.width < 1024) {
        this.static = false
      } else {
        this.static = true
      }
    }
  },

  beforeMount() {
    window.addEventListener('resize', this.resize)
    this.resize()
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.resize)
  }
}
</script>
